export default __webpack_public_path__ + "static/media/SG.f10f7273.svg";